import { FormControl, Stack, FormLabel, Box, Text } from '@chakra-ui/react';
import { Field } from 'formik';
import { useCompanyForm } from 'pages/organisations/companies/v5/hooks/useCompanyForm';
import BooleanToggle from '@/components/forms/new/formikFormFields/BooleanToggle';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import { FORM_FIELD_PATHS } from '../../constants';

const PaymentBannerToggle = ({ darkMode }) => {
    const { formData, updateFormData } = useCompanyForm();

    const handleChange = (value) => {
        updateFormData(FORM_FIELD_PATHS.PAYMENT_BANNER_ENABLED, value);
    };

    return (
        <FormControl sx={{ margin: '0 !important' }}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling()}
                align="center">
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Non-Payment Banner
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Show a non-dismissable banner to this wholesaler on
                        every page while they are in late payment status.
                    </Text>
                </Box>
                <Box flex={1}>
                    <Field
                        component={BooleanToggle}
                        id={FORM_FIELD_PATHS.PAYMENT_BANNER_ENABLED}
                        name={FORM_FIELD_PATHS.PAYMENT_BANNER_ENABLED}
                        isChecked={Boolean(formData?.displayPaymentBanner)}
                        onChange={handleChange}
                    />
                </Box>
            </Stack>
        </FormControl>
    );
};

export default PaymentBannerToggle;
